import { render } from "./RegistrationClinicStepOne.vue?vue&type=template&id=ec96e2d6&scoped=true"
import script from "./RegistrationClinicStepOne.vue?vue&type=script&lang=js"
export * from "./RegistrationClinicStepOne.vue?vue&type=script&lang=js"

import "./RegistrationClinicStepOne.vue?vue&type=style&index=0&id=ec96e2d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec96e2d6"]])

export default __exports__